/**
 * Performance section — self-contained fade-right + yellow strike (matches oddfishmedia.com.au).
 * Does not rely on global home-strikes.js so hero/scroll races cannot skip animations.
 */
(function () {
  "use strict";

  var SECTION_SEL = ".oddfish-first-section.first_section_home";
  var STRIKE_DELAY = 400;

  function heroIsCovering() {
    var hero = document.querySelector(".oddfish-homepage-hero");
    return hero && !hero.classList.contains("is-hidden") && !hero.classList.contains("slide-out-top");
  }

  function getSection(root) {
    return (root || document).querySelector(SECTION_SEL);
  }

  function sectionReached(section) {
    if (heroIsCovering()) return false;

    var strike = section.querySelector(".strike");
    if (!strike) return false;

    var rect = strike.getBoundingClientRect();
    var viewportBottom = window.innerHeight - 80;

    /* Match live oddfish-home.js — trigger when the highlighted word enters view. */
    return rect.top < viewportBottom && rect.bottom > 80;
  }

  function resetSection(section) {
    if (!section) return;

    section.classList.remove("scrolled", "oddfish-perf-ready");
    delete section.dataset.oddfishPerfPlayed;

    var left = section.querySelector(".oddfish-first-section__left");
    if (left) left.classList.remove("oddfish-perf-revealed");

    var strike = section.querySelector(".strike");
    if (strike) {
      strike.classList.remove("strike-visible", "oddfish-strike-visible");
      delete strike.dataset.oddfishPerfStrikePlayed;
    }
  }

  function playStrike(strike) {
    if (!strike || strike.dataset.oddfishPerfStrikePlayed === "1") return;

    window.setTimeout(function () {
      if (strike.dataset.oddfishPerfStrikePlayed === "1") return;
      strike.classList.remove("strike-visible", "oddfish-strike-visible");
      void strike.offsetWidth;
      requestAnimationFrame(function () {
        strike.classList.add("strike-visible");
        strike.dataset.oddfishPerfStrikePlayed = "1";
      });
    }, STRIKE_DELAY);
  }

  function revealSection(section, force) {
    if (!section || section.dataset.oddfishPerfPlayed === "1") return;
    if (heroIsCovering()) return;
    if (!force && !sectionReached(section)) return;

    var left = section.querySelector(".oddfish-first-section__left");
    var strike = section.querySelector(".strike");
    if (!left || !strike) return;

    section.dataset.oddfishPerfPlayed = "1";
    section.classList.add("scrolled", "oddfish-perf-ready");

    left.classList.remove("oddfish-perf-revealed");
    void left.offsetWidth;
    requestAnimationFrame(function () {
      left.classList.add("oddfish-perf-revealed");
    });

    playStrike(strike);
  }

  function checkReveal(root, force) {
    revealSection(getSection(root), force);
  }

  function bindSection(section) {
    if (!section || section.dataset.oddfishPerfBound === "1") return;
    section.dataset.oddfishPerfBound = "1";

    /* Strip any classes forced by global home-strikes.js */
    function guardAgainstGlobalStrikes() {
      if (section.dataset.oddfishPerfPlayed === "1") return;

      var left = section.querySelector(".oddfish-first-section__left");
      var strike = section.querySelector(".strike");

      if (left && left.classList.contains("aos-animate")) {
        left.classList.remove("aos-animate");
      }
      if (strike && strike.classList.contains("strike-visible") && !section.classList.contains("oddfish-perf-ready")) {
        strike.classList.remove("strike-visible", "oddfish-strike-visible");
      }
    }

    window.addEventListener("scroll", guardAgainstGlobalStrikes, { passive: true });
  }

  function initButtons(scope) {
    (scope || document).querySelectorAll(".oddfish-first-section .oddfish-black-btn").forEach(function (btn) {
      if (btn.dataset.oddfishBtnBound === "1") return;
      btn.dataset.oddfishBtnBound = "1";
      btn.addEventListener("mouseenter", function () {
        this.classList.add("is-hovered");
      });
      btn.addEventListener("mouseleave", function () {
        this.classList.remove("is-hovered");
      });
    });
  }

  function boot(root) {
    var section = getSection(root);
    if (!section) return;

    bindSection(section);
    initButtons(root);

    function tryReveal(force) {
      checkReveal(root, force);
    }

    if (!heroIsCovering()) {
      tryReveal(false);
    }

    window.addEventListener("oddfish-hero-hidden", function () {
      tryReveal(true);
    }, { passive: true });
    window.addEventListener("scroll", function () {
      tryReveal(false);
    }, { passive: true });
    window.addEventListener("resize", function () {
      tryReveal(false);
    }, { passive: true });
    window.addEventListener("load", function () {
      tryReveal(false);
    }, { passive: true });

    requestAnimationFrame(function () {
      tryReveal(false);
    });
    window.setTimeout(function () {
      tryReveal(false);
    }, 50);
    window.setTimeout(function () {
      tryReveal(false);
    }, 200);
    window.setTimeout(function () {
      tryReveal(false);
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    resetSection(getSection());
    boot();
  });

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector(SECTION_SEL);
    if (!section) return;
    resetSection(section);
    delete section.dataset.oddfishPerfBound;
    boot(e.target);
  });
})();
